export default {
    GET_VOA: "[zina_flow][voa] get all voa",
    GET_VOA_SUCCESS: "[zina_flow][voa] get all voa SUCCESS",
    GET_VOA_FAIL: "[zina_flow][voa] get all voa FAIL",
    UPDATE_PAGINATION: "[zina_flow][voa] update voa pagination",
    CHANGE_PAGE: "[zina_flow][voa] change voa page",
    FILTER_LIST: "[zina_flow][voa] change voa filters",
    GET_VOA_DETAIL: "[zina_flow][voa] get voa detail",
    GET_VOA_DETAIL_SUCCESS: "[zina_flow][voa] get voa detail SUCCESS",
    GET_VOA_DETAIL_FAIL: "[zina_flow][voa] get voa detail FAIL"
};
